import React, { useState } from "react";
import CustomModal from "../Common/CustomModal";
import { Box, useMediaQuery } from "@mui/material";
import { CustomInput } from "../Common/CustomInput";
import { TitleSharp } from "@mui/icons-material";
import { colors } from "../../theme/theme";
import ImageUploadInput from "../Common/ImageUploadInput";
import { CustomBtn } from "../Common/CustomBtn";
import axiosInstance from "../../utils/config/config";
import { useSelector } from "react-redux";

const CreateGroupModal = ({
  open,
  onClose,
  setLoading,
  setErrorState,
  setSuccess,
}) => {
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { userData } = useSelector((state) => state.user);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);

  const handlePublish = async () => {
    setErrorState({
      error: false,
      errorMsg: "",
    });

    if (!title || !description || !image) {
      setErrorState({
        error: true,
        errorMsg: "Please fill all the fields",
      });
      return;
    }

    try {
      setLoading(true);

      onClose();
      const response = await axiosInstance.post("/group/createGroup", {
        title: title,
        description: description,
        image_url: image,
        created_by: userData?.id,
        status: "active",
        points_of_joining: 14,
      });

      if (response?.status === 200) {
        setErrorState({
          error: false,
          errorMsg: "",
        });
        setSuccess(true);
        setLoading(false);
        setTitle("");
        setDescription("");
        setImage(null);
      }
    } catch (error) {
      setErrorState({
        error: true,
        errorMsg: error?.data?.response?.message || "Failed to create group",
      });
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <CustomModal open={open} onClose={onClose} title="Create Group">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: smScreen ? "100%" : "50%",
          margin: "0 auto",
        }}
      >
        <CustomInput
          label={"Group Title"}
          value={title}
          handleChange={(e) => setTitle(e.target.value)}
          placeholder={"Enter group title"}
          Icon={TitleSharp}
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
        />
        <CustomInput
          label={"Group Description"}
          value={description}
          handleChange={(e) => setDescription(e.target.value)}
          placeholder={"Enter group description"}
          noIcon
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
          textArea
        />
        <ImageUploadInput
          image={image}
          setImage={setImage}
          width={"90%"}
          label={"Group Image"}
        />
        <CustomBtn
          text={"Publish"}
          width={"100%"}
          height={"50px"}
          mt={2}
          mb={2}
          onClick={handlePublish}
        />
      </Box>
    </CustomModal>
  );
};

export default CreateGroupModal;
